import React from "react";

function Robot() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="242"
            height="235"
            fill="none"
            viewBox="0 0 242 235"
        >
            <g clipPath="url(#clip0_228_1323)">
                <path
                    fill="#F4F7FA"
                    d="M116.96.053c61.805-1.823 115.342 42.99 123.431 101.791 8.844 64.29-39.831 122.133-99.722 131.401C66.174 244.769-6.082 178.102.406 105.777 5.294 51.287 54.132 1.907 116.96.053z"
                ></path>
                <path
                    fill="#26264F"
                    d="M12.542 205.278l214.104-1.824v5.396c0 1.465-.933 2.71-2.198 2.932l-60.543 10.625a8.45 8.45 0 01-2.172.1L14.865 210.393c-1.312-.108-2.327-1.357-2.327-2.863l.004-2.252z"
                ></path>
                <path
                    fill="#26264F"
                    d="M90.24 196.632l134.193 9.871c2.401.176 4.353-1.701 4.353-4.194v-99.856c0-2.492-1.952-4.513-4.353-4.513H90.24c-1.978 0-3.578 1.827-3.578 4.08v90.268c0 2.254 1.6 4.198 3.578 4.344z"
                ></path>
                <path
                    fill="url(#paint0_linear_228_1323)"
                    d="M88.1 196.632l134.192 9.871c2.402.176 4.354-1.701 4.354-4.194v-99.856c0-2.492-1.952-4.513-4.354-4.513H88.1c-1.979 0-3.578 1.827-3.578 4.08v90.268c0 2.254 1.6 4.198 3.578 4.344z"
                ></path>
                <path
                    fill="url(#paint1_linear_228_1323)"
                    d="M92.28 190.267l124.99 8.574c1.954.134 3.542-1.406 3.542-3.441v-87.423c0-2.035-1.592-3.691-3.542-3.7l-124.99-.538c-1.63-.008-2.951 1.489-2.951 3.343v79.628c0 1.851 1.32 3.443 2.952 3.557z"
                ></path>
                <path
                    fill="#fff"
                    d="M150.457 100.671c0 .929.691 1.682 1.544 1.686.854.003 1.547-.749 1.547-1.68 0-.93-.693-1.684-1.547-1.684-.853-.001-1.544.751-1.544 1.678z"
                ></path>
                <path
                    fill="#fff"
                    d="M222.293 206.503l-133.514-9.822-.68-.05c-.907-.067-1.732-.515-2.363-1.195 9.608-.526 15.576-3.937 19.425-7.455 7.731-7.07 6.39-14.042 14.727-18.69 10.394-5.798 18.574 1.549 26.464-5.7 4.784-4.395 2.431-7.672 8.321-14.241 6.52-7.273 10.764-4.828 17.316-11.375 8.284-8.278 4.141-14.717 11.277-20.66 8.657-7.209 17.993-.537 26.234-7.45 3.554-2.983 5.504-7.318 6.523-11.929h6.269c2.402 0 4.354 2.02 4.354 4.513v99.86c0 2.493-1.952 4.369-4.353 4.194z"
                    opacity="0.48"
                ></path>
                <path
                    fill="url(#paint2_linear_228_1323)"
                    d="M82.751 196.084l143.895 10.387-62.741 11.011a8.54 8.54 0 01-2.172.1L12.542 205.275l67.92-9.124a11.084 11.084 0 012.29-.067z"
                ></path>
                <path
                    fill="#26264F"
                    d="M205.65 206.563l-119.797-8.779-37.075 4.941 118.764 9.384 38.108-5.546z"
                ></path>
                <g fill="#fff" opacity="0.67">
                    <path
                        d="M174.285 141.847c-2.552-4.958-7.321-8.565-12.894-9.382l-.388-24.03c15.923.793 29.753 11.101 35.982 25.6l-22.7 7.812zM143.236 151.703c1.341 7.992 8.054 14.353 16.213 14.752a15.911 15.911 0 006.812-1.153l12.503 21.277c-5.79 2.841-12.377 4.231-19.315 3.782-20.477-1.325-36.892-18.244-38.729-38.595l22.516-.063zM182.643 184.39l-12.566-21.315c3.772-2.987 6.196-7.684 6.196-13.067 0-1.277-.138-2.55-.411-3.798l22.748-7.742a42.687 42.687 0 011.856 12.458c0 14.291-7.097 26.531-17.823 33.464z"
                        opacity="0.67"
                    ></path>
                </g>
                <path
                    fill="url(#paint3_linear_228_1323)"
                    d="M156.961 132.427c-7.447.952-13.214 7.036-13.901 14.771l-37.113.221v-.051c0-29.285 21.868-53.192 50.372-54.825l.642 39.884z"
                ></path>
                <path
                    fill="#EBEFF2"
                    d="M228.595 26.052v60.355c0 2.004-1.658 3.628-3.702 3.628H100.599a3.564 3.564 0 01-3.29-2.195 3.558 3.558 0 01-.272-1.362V27.3l131.558-1.247z"
                ></path>
                <path
                    fill="#D8DEE8"
                    d="M100.599 19.75l124.294-1.321c2.044-.022 3.702 1.585 3.702 3.588v6.185l-131.56 1.21v-6.068a3.6 3.6 0 013.564-3.595zM198.241 58.302l-6.849-23.475c-10.366 3.373-17.856 12.975-17.916 24.26l24.765-.785z"
                ></path>
                <path
                    fill="#fff"
                    d="M179.879 60.544c.385 5.367 3.004 10.12 6.951 13.364l10.751-13.944-17.702.58zM199.77 57.494c4.148-3.928 9.15-8.675 13.126-12.467a19.604 19.604 0 00-13.536-5.225c-1.554.01-3.102.203-4.611.572l5.021 17.12zM200.638 58.962l15.042 10.8a19.034 19.034 0 00-1.61-23.55l-3.667 3.49c-4.065 3.862-8.149 7.73-9.765 9.26zM200.203 60.7l.29 17.623a19.77 19.77 0 0014.188-7.225L200.203 60.7zM198.536 61.453l-10.377 13.454a19.623 19.623 0 0010.655 3.443l-.278-16.897zM106.275 46.453l63.695-.42v-5.97l-63.695.478v5.912zM106.275 57.152l63.695-.317v-5.97l-63.695.375v5.912zM106.275 67.85l63.695-.213v-5.969l-63.695.27v5.913zM106.275 78.55l63.695-.111v-5.97l-63.695.168v5.913zM220.097 23.31a1.604 1.604 0 001.02 1.48c.198.079.41.116.623.112a1.647 1.647 0 001.643-1.628 1.607 1.607 0 00-1.643-1.592 1.65 1.65 0 00-1.643 1.628zM64.426 104.789l4.633 7.078-23.153 15.134-4.633-7.078 23.153-15.134z"
                ></path>
                <path
                    fill="url(#paint4_linear_228_1323)"
                    d="M64.955 116.38c-4.833 0-8.75-3.915-8.75-8.744s3.917-8.743 8.75-8.743c4.832 0 8.75 3.914 8.75 8.743 0 4.829-3.918 8.744-8.75 8.744z"
                ></path>
                <path
                    fill="url(#paint5_linear_228_1323)"
                    d="M42.058 122.628a7.18 7.18 0 015.343-8.637 7.18 7.18 0 113.301 13.976 7.186 7.186 0 01-8.644-5.339z"
                ></path>
                <path
                    fill="url(#paint6_linear_228_1323)"
                    d="M49.394 86.524c-6.087 0-11.022-6.93-11.022-15.479s4.935-15.479 11.022-15.479c6.088 0 11.023 6.93 11.023 15.479s-4.935 15.479-11.023 15.479z"
                ></path>
                <path
                    fill="url(#paint7_linear_228_1323)"
                    d="M83.08 33.539h20.748c21.272 0 38.516 17.23 38.516 38.488 0 11.342-9.201 20.537-20.553 20.537H65.119c-11.35 0-20.553-9.195-20.553-20.537 0-21.257 17.245-38.488 38.513-38.488z"
                ></path>
                <path
                    fill="url(#paint8_linear_228_1323)"
                    d="M86.726 134.649h13.454c13.801 0 24.989-11.179 24.989-24.969 0-3.534-1.405-6.923-3.905-9.422a13.342 13.342 0 00-9.429-3.902H75.067a13.336 13.336 0 00-9.426 3.904 13.317 13.317 0 00-3.903 9.42c0 13.794 11.187 24.969 24.988 24.969z"
                ></path>
                <path
                    fill="url(#paint9_linear_228_1323)"
                    d="M64.252 84.263h39.434c5.344 0 9.729-4.094 9.729-9.144v-7.742c0-5.05-4.385-9.003-9.729-8.833l-39.434 1.257c-4.773.151-8.599 4.078-8.599 8.77v7.194c0 4.694 3.825 8.498 8.599 8.498z"
                ></path>
                <path
                    fill="#fff"
                    d="M91.052 70.837c0 3.373 2.873 6.07 6.445 6.025 3.605-.046 6.551-2.862 6.551-6.289 0-3.427-2.946-6.123-6.55-6.022-3.573.1-6.446 2.914-6.446 6.286zM64.402 71.379c0 3.259 2.683 5.863 6.018 5.825 3.364-.043 6.113-2.764 6.113-6.072 0-3.307-2.749-5.917-6.113-5.822-3.335.093-6.018 2.81-6.018 6.069z"
                ></path>
                <path
                    fill="#fff"
                    d="M79.144 87.165c5.868-6.885 3.26-12.392 10.926-21.723 10.55-12.836 22.857-11.387 25.676-20.095.782-2.413.871-5.725-1.223-10.303 16.068 4.631 27.821 19.434 27.821 36.983 0 11.342-9.201 20.537-20.553 20.537h-49.39c2.96-1.611 5.121-3.494 6.743-5.398z"
                    opacity="0.3"
                ></path>
                <path
                    fill="url(#paint10_linear_228_1323)"
                    d="M136.802 86.416c-6.088 0-11.023-6.93-11.023-15.478 0-8.549 4.935-15.479 11.023-15.479 6.087 0 11.022 6.93 11.022 15.479 0 8.548-4.935 15.478-11.022 15.478z"
                ></path>
                <path
                    fill="url(#paint11_linear_228_1323)"
                    d="M145.522 77.706c-2.662 0-4.821-3.03-4.821-6.768s2.159-6.769 4.821-6.769 4.82 3.03 4.82 6.769c0 3.738-2.158 6.768-4.82 6.768z"
                ></path>
                <path
                    style={{ mixBlendMode: "multiply" }}
                    fill="url(#paint12_linear_228_1323)"
                    d="M83.414 120.903c1.844-8.665 22.272-8.461 22.827-14.121.428-4.366-11.299-8.69-12.772-9.232a44.79 44.79 0 00-3.75-1.194h22.12c3.536 0 6.928 1.403 9.428 3.902a13.319 13.319 0 013.906 9.422c0 13.79-11.188 24.969-24.989 24.969H86.725a25.09 25.09 0 01-3.803-.287c1.174-1.451 1.935-3.038 2.12-4.769.408-3.839-2.347-5.332-1.628-8.69z"
                    opacity="0.4"
                ></path>
                <path
                    fill="url(#paint13_linear_228_1323)"
                    d="M93.123 99.67c-11.74 0-21.256-1.152-21.256-2.572 0-1.42 9.517-2.572 21.256-2.572 11.74 0 21.257 1.151 21.257 2.572 0 1.42-9.517 2.571-21.257 2.571z"
                ></path>
                <path
                    fill="#fff"
                    d="M120.406 104.787l4.633 7.078-23.153 15.134-4.633-7.078 23.153-15.134z"
                ></path>
                <path
                    fill="url(#paint14_linear_228_1323)"
                    d="M120.931 116.38c-4.833 0-8.751-3.915-8.751-8.744s3.918-8.743 8.751-8.743c4.832 0 8.75 3.914 8.75 8.743 0 4.829-3.918 8.744-8.75 8.744z"
                ></path>
                <path
                    fill="#fff"
                    d="M100.943 118.599H80.676l.805 8.38 19.865-.664-.403-7.716z"
                ></path>
                <path
                    fill="url(#paint15_linear_228_1323)"
                    d="M99.938 126.065a7.176 7.176 0 010-10.154 7.19 7.19 0 0110.161 0 7.176 7.176 0 010 10.154 7.188 7.188 0 01-10.161 0z"
                ></path>
                <path
                    fill="url(#paint16_linear_228_1323)"
                    d="M78.909 118.364c1.228-.687 2.962-1.173 5.402-1.081a2.354 2.354 0 012.254 2.072l.706 5.995H76.814l-.34-1.431a5.023 5.023 0 012.434-5.555z"
                ></path>
                <path
                    fill="url(#paint17_linear_228_1323)"
                    d="M60.446 125.492l37.717-.65a1.583 1.583 0 011.312.658l1.15 1.6a1.219 1.219 0 01.103 1.257 1.222 1.222 0 01-1.063.679l-39.923 1.11.704-4.654z"
                ></path>
                <path
                    fill="url(#paint18_linear_228_1323)"
                    d="M19.962 107.151l38.89-1.81a3.278 3.278 0 012.879 1.464l15.012 22.76-41.129 1.072a3.349 3.349 0 01-2.84-1.44l-13.831-19.981a1.318 1.318 0 011.02-2.065z"
                ></path>
                <path
                    style={{ mixBlendMode: "multiply" }}
                    fill="url(#paint19_linear_228_1323)"
                    d="M61.731 106.804a3.275 3.275 0 00-2.879-1.464l-.851.04c-.045 1.261-.354 2.429-1.06 3.408-2.204 3.048-6.3 1.528-9.064 4.781-3.037 3.573.237 7.371-2.47 10.69-2.85 3.492-7.983 1.14-13.543 3.621l.91 1.316a3.34 3.34 0 002.84 1.44l41.13-1.072-15.013-22.76z"
                    opacity="0.3"
                ></path>
                <path
                    fill="#fff"
                    d="M111.15 155.429v50.349c0 1.675-1.25 2.961-2.789 2.88l-88.58-4.647c-1.327-.07-2.401-1.381-2.401-2.928v-46.615l93.77.961z"
                    opacity="0.68"
                ></path>
                <path
                    fill="url(#paint20_linear_228_1323)"
                    d="M19.78 148.566l88.581.457c1.539.008 2.789 1.37 2.789 3.041v5.159l-93.77-1.089v-4.775c0-1.55 1.074-2.799 2.4-2.793z"
                ></path>
                <path
                    fill="#fff"
                    d="M104.76 153.022c0 .738.551 1.34 1.231 1.35.681.01 1.234-.586 1.234-1.33 0-.744-.553-1.346-1.234-1.351-.68-.005-1.231.591-1.231 1.331zM92.026 201.286l6.97.329V164.19l-6.97-.121v37.217z"
                ></path>
                <path
                    fill="url(#paint21_linear_228_1323)"
                    d="M92.026 201.286l6.97.329v-17.769l-6.97-.229v17.669z"
                ></path>
                <path
                    fill="#fff"
                    d="M82.456 200.833l6.863.324v-37.135l-6.863-.119v36.93z"
                ></path>
                <path
                    fill="url(#paint22_linear_228_1323)"
                    d="M82.456 200.833l6.863.324v-8.815l-6.863-.275v8.766z"
                ></path>
                <path
                    fill="#fff"
                    d="M73.033 200.388l6.758.319v-36.85l-6.758-.117v36.648z"
                ></path>
                <path
                    fill="url(#paint23_linear_228_1323)"
                    d="M73.033 200.388l6.758.319v-4.592l-6.758-.294v4.567z"
                ></path>
                <path
                    fill="#fff"
                    d="M63.751 199.95l6.657.314v-36.569l-6.657-.116v36.371z"
                ></path>
                <path
                    fill="url(#paint24_linear_228_1323)"
                    d="M63.751 199.95l6.657.314v-28.648l-6.657-.158v28.492z"
                ></path>
                <path
                    fill="#fff"
                    d="M54.61 199.518l6.557.31v-36.293l-6.556-.114v36.097z"
                ></path>
                <path
                    fill="url(#paint25_linear_228_1323)"
                    d="M54.61 199.518l6.557.31v-25.201l-6.556-.173v25.064z"
                ></path>
                <path
                    fill="#fff"
                    d="M45.606 199.093l6.46.305v-36.021l-6.46-.112v35.828z"
                ></path>
                <path
                    fill="url(#paint26_linear_228_1323)"
                    d="M45.606 199.093l6.46.305v-30.783l-6.46-.14v30.618z"
                ></path>
                <path
                    fill="#fff"
                    d="M36.735 198.674l6.363.3v-35.753l-6.363-.11v35.563z"
                ></path>
                <path
                    fill="url(#paint27_linear_228_1323)"
                    d="M36.735 198.674l6.363.3v-21.961l-6.363-.183v21.844z"
                ></path>
                <path
                    fill="#fff"
                    d="M27.995 198.261l6.269.296v-35.489l-6.269-.108v35.301z"
                ></path>
                <path
                    fill="url(#paint28_linear_228_1323)"
                    d="M27.995 198.261l6.269.296v-12.321l-6.269-.231v12.256z"
                ></path>
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_228_1323"
                    x1="226.646"
                    x2="84.522"
                    y1="152.227"
                    y2="152.227"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#444B8C"></stop>
                    <stop offset="1" stopColor="#26264F"></stop>
                </linearGradient>
                <linearGradient
                    id="paint1_linear_228_1323"
                    x1="220.81"
                    x2="89.329"
                    y1="151.294"
                    y2="151.294"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#AA80F9"></stop>
                    <stop offset="1" stopColor="#6165D7"></stop>
                </linearGradient>
                <linearGradient
                    id="paint2_linear_228_1323"
                    x1="226.646"
                    x2="12.542"
                    y1="206.834"
                    y2="206.834"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#444B8C"></stop>
                    <stop offset="1" stopColor="#26264F"></stop>
                </linearGradient>
                <linearGradient
                    id="paint3_linear_228_1323"
                    x1="135.49"
                    x2="76.432"
                    y1="124.269"
                    y2="66.064"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E38DDD"></stop>
                    <stop offset="1" stopColor="#9571F6"></stop>
                </linearGradient>
                <linearGradient
                    id="paint4_linear_228_1323"
                    x1="73.705"
                    x2="56.205"
                    y1="107.636"
                    y2="107.636"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#40447E"></stop>
                    <stop offset="1" stopColor="#3C3B6B"></stop>
                </linearGradient>
                <linearGradient
                    id="paint5_linear_228_1323"
                    x1="56.243"
                    x2="41.873"
                    y1="120.989"
                    y2="120.989"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#40447E"></stop>
                    <stop offset="1" stopColor="#3C3B6B"></stop>
                </linearGradient>
                <linearGradient
                    id="paint6_linear_228_1323"
                    x1="60.417"
                    x2="38.372"
                    y1="71.045"
                    y2="71.045"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FFC444"></stop>
                    <stop offset="1" stopColor="#F36F56"></stop>
                </linearGradient>
                <linearGradient
                    id="paint7_linear_228_1323"
                    x1="142.344"
                    x2="44.566"
                    y1="63.051"
                    y2="63.051"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FCB148"></stop>
                    <stop offset="0.05" stopColor="#FDBA46"></stop>
                    <stop offset="0.14" stopColor="#FFC244"></stop>
                    <stop offset="0.32" stopColor="#FFC444"></stop>
                    <stop offset="0.48" stopColor="#FDB946"></stop>
                    <stop offset="0.78" stopColor="#F99C4D"></stop>
                    <stop offset="0.87" stopColor="#F8924F"></stop>
                    <stop offset="1" stopColor="#F8924F"></stop>
                </linearGradient>
                <linearGradient
                    id="paint8_linear_228_1323"
                    x1="125.173"
                    x2="61.738"
                    y1="115.502"
                    y2="115.502"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FCB148"></stop>
                    <stop offset="0.05" stopColor="#FDBA46"></stop>
                    <stop offset="0.14" stopColor="#FFC244"></stop>
                    <stop offset="0.32" stopColor="#FFC444"></stop>
                    <stop offset="0.48" stopColor="#FDB946"></stop>
                    <stop offset="0.78" stopColor="#F99C4D"></stop>
                    <stop offset="0.87" stopColor="#F8924F"></stop>
                    <stop offset="1" stopColor="#F8924F"></stop>
                </linearGradient>
                <linearGradient
                    id="paint9_linear_228_1323"
                    x1="113.415"
                    x2="55.653"
                    y1="71.401"
                    y2="71.401"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#444B8C"></stop>
                    <stop offset="1" stopColor="#26264F"></stop>
                </linearGradient>
                <linearGradient
                    id="paint10_linear_228_1323"
                    x1="147.824"
                    x2="125.78"
                    y1="70.938"
                    y2="70.938"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FFC444"></stop>
                    <stop offset="1" stopColor="#F36F56"></stop>
                </linearGradient>
                <linearGradient
                    id="paint11_linear_228_1323"
                    x1="150.341"
                    x2="140.701"
                    y1="70.938"
                    y2="70.938"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FFC444"></stop>
                    <stop offset="1" stopColor="#F36F56"></stop>
                </linearGradient>
                <linearGradient
                    id="paint12_linear_228_1323"
                    x1="125.173"
                    x2="82.922"
                    y1="115.502"
                    y2="115.502"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FCB148"></stop>
                    <stop offset="0.05" stopColor="#FDBA46"></stop>
                    <stop offset="0.14" stopColor="#FFC244"></stop>
                    <stop offset="0.32" stopColor="#FFC444"></stop>
                    <stop offset="0.48" stopColor="#FDB946"></stop>
                    <stop offset="0.78" stopColor="#F99C4D"></stop>
                    <stop offset="0.87" stopColor="#F8924F"></stop>
                    <stop offset="1" stopColor="#F8924F"></stop>
                </linearGradient>
                <linearGradient
                    id="paint13_linear_228_1323"
                    x1="102.635"
                    x2="96.531"
                    y1="170.633"
                    y2="123.377"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FCB148"></stop>
                    <stop offset="0.05" stopColor="#FDBA46"></stop>
                    <stop offset="0.14" stopColor="#FFC244"></stop>
                    <stop offset="0.32" stopColor="#FFC444"></stop>
                    <stop offset="0.4" stopColor="#FEC045"></stop>
                    <stop offset="0.71" stopColor="#FAA34B"></stop>
                    <stop offset="0.87" stopColor="#F8924F"></stop>
                    <stop offset="1" stopColor="#F8924F"></stop>
                </linearGradient>
                <linearGradient
                    id="paint14_linear_228_1323"
                    x1="129.681"
                    x2="112.18"
                    y1="107.636"
                    y2="107.636"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#40447E"></stop>
                    <stop offset="1" stopColor="#3C3B6B"></stop>
                </linearGradient>
                <linearGradient
                    id="paint15_linear_228_1323"
                    x1="112.203"
                    x2="97.834"
                    y1="120.988"
                    y2="120.988"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#40447E"></stop>
                    <stop offset="1" stopColor="#3C3B6B"></stop>
                </linearGradient>
                <linearGradient
                    id="paint16_linear_228_1323"
                    x1="87.271"
                    x2="76.337"
                    y1="121.313"
                    y2="121.313"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#40447E"></stop>
                    <stop offset="1" stopColor="#3C3B6B"></stop>
                </linearGradient>
                <linearGradient
                    id="paint17_linear_228_1323"
                    x1="100.859"
                    x2="59.744"
                    y1="127.494"
                    y2="127.494"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#AA80F9"></stop>
                    <stop offset="1" stopColor="#6165D7"></stop>
                </linearGradient>
                <linearGradient
                    id="paint18_linear_228_1323"
                    x1="76.743"
                    x2="18.703"
                    y1="117.988"
                    y2="117.988"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#AA80F9"></stop>
                    <stop offset="1" stopColor="#6165D7"></stop>
                </linearGradient>
                <linearGradient
                    id="paint19_linear_228_1323"
                    x1="76.743"
                    x2="31.864"
                    y1="117.988"
                    y2="117.988"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#AA80F9"></stop>
                    <stop offset="1" stopColor="#6165D7"></stop>
                </linearGradient>
                <linearGradient
                    id="paint20_linear_228_1323"
                    x1="56.547"
                    x2="98.338"
                    y1="141.033"
                    y2="209.402"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF9085"></stop>
                    <stop offset="1" stopColor="#FB6FBB"></stop>
                </linearGradient>
                <linearGradient
                    id="paint21_linear_228_1323"
                    x1="91.442"
                    x2="101.101"
                    y1="179.881"
                    y2="210.045"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF9085"></stop>
                    <stop offset="1" stopColor="#FB6FBB"></stop>
                </linearGradient>
                <linearGradient
                    id="paint22_linear_228_1323"
                    x1="83.617"
                    x2="89.007"
                    y1="189.506"
                    y2="206.337"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF9085"></stop>
                    <stop offset="1" stopColor="#FB6FBB"></stop>
                </linearGradient>
                <linearGradient
                    id="paint23_linear_228_1323"
                    x1="74.993"
                    x2="78.359"
                    y1="193.827"
                    y2="204.339"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF9085"></stop>
                    <stop offset="1" stopColor="#FB6FBB"></stop>
                </linearGradient>
                <linearGradient
                    id="paint24_linear_228_1323"
                    x1="60.859"
                    x2="75.63"
                    y1="166.386"
                    y2="212.514"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF9085"></stop>
                    <stop offset="1" stopColor="#FB6FBB"></stop>
                </linearGradient>
                <linearGradient
                    id="paint25_linear_228_1323"
                    x1="52.365"
                    x2="65.481"
                    y1="169.846"
                    y2="210.81"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF9085"></stop>
                    <stop offset="1" stopColor="#FB6FBB"></stop>
                </linearGradient>
                <linearGradient
                    id="paint26_linear_228_1323"
                    x1="42.202"
                    x2="57.953"
                    y1="163.168"
                    y2="212.359"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF9085"></stop>
                    <stop offset="1" stopColor="#FB6FBB"></stop>
                </linearGradient>
                <linearGradient
                    id="paint27_linear_228_1323"
                    x1="35.053"
                    x2="46.599"
                    y1="172.68"
                    y2="208.735"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF9085"></stop>
                    <stop offset="1" stopColor="#FB6FBB"></stop>
                </linearGradient>
                <linearGradient
                    id="paint28_linear_228_1323"
                    x1="28.201"
                    x2="35.152"
                    y1="183.116"
                    y2="204.824"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF9085"></stop>
                    <stop offset="1" stopColor="#FB6FBB"></stop>
                </linearGradient>
                <clipPath id="clip0_228_1323">
                    <path
                        fill="#fff"
                        d="M0 0H241.433V234.55H0z"
                        transform="matrix(-1 0 0 1 241.433 0)"
                    ></path>
                </clipPath>
            </defs>
        </svg>
    );
}

export default Robot;
